import { Navigate } from 'react-router-dom';
import { useStore } from '@hooks/useStore';
import { ProtectedRouteProps } from './types';
import { AuthSessionGate } from './AuthSessionGate';

const SavingsProtected = ({ permissions, element, requireAll = false }: ProtectedRouteProps) => {
  const { authStore } = useStore();
  const { hasPermission, hasEveryPermission, user } = authStore;

  const permitted = requireAll ? hasEveryPermission(permissions) : hasPermission(permissions);
  const canAccessSavings = !!user?.canManageSavingsAccounts && permitted;

  return (
    <AuthSessionGate>
      {canAccessSavings ? element ?? null : <Navigate to="/dashboard" replace />}
    </AuthSessionGate>
  );
};

export default SavingsProtected;
